// services/supplierService.js
import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const supplierService = {
  // Get all suppliers with pagination
  getAllSuppliers: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.SUPPLIERS}`, { 
        params: {
          page: params.page || 1,
          per_page: params.per_page || 15,
          ...params
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get active suppliers
  getActiveSuppliers: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.ACTIVE_SUPPLIERS}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get supplier by ID
  getSupplierById: async (supplierId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.SUPPLIER_BY_ID(supplierId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new supplier
  createSupplier: async (supplierData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.SUPPLIERS}`, supplierData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update supplier
  updateSupplier: async (supplierId, supplierData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.SUPPLIER_BY_ID(supplierId)}`, supplierData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete supplier
  deleteSupplier: async (supplierId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${API_URLS.SUPPLIER_BY_ID(supplierId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default supplierService;